import { IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountInstitution = (account: IAccount) => {
  return account.institution;
};
